import React from 'react';

import { OpenInNew } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';

import { useGetHeatmapSurchargePdf } from '~/hooks/apis/lere/useGetHeatmapSurchargePdf';

import { isMatchingPdf } from './utils';

interface Props {
  offerId: string;
  generatedAt: string;
}

export default function HeatmapPdfLink({ offerId, generatedAt }: Props) {
  const pdf = useGetHeatmapSurchargePdf(offerId, true, generatedAt);
  if (pdf.isPending) return <Typography variant="body2">Loading full heatmap link…</Typography>;
  if (pdf.data && isMatchingPdf(generatedAt, pdf.data.generatedAt, pdf.data.expiresAt)) {
    return (
      <Button
        variant="text"
        href={pdf.data.pdfUrl}
        target="_blank"
        rel="noopener noreferrer"
        endIcon={<OpenInNew />}
        sx={{ alignSelf: 'flex-start' }}
      >
        Open full heatmap
      </Button>
    );
  }
  return (
    <Stack spacing={1}>
      <Typography variant="body2" color="text.secondary">
        {pdf.isError
          ? 'The PDF link could not be loaded.'
          : 'The PDF link has expired or a newer forecast is available. Refresh the page data to view the matching PDF.'}
      </Typography>
      <Button variant="text" disabled={pdf.isFetching} onClick={() => pdf.refetch()} sx={{ alignSelf: 'flex-start' }}>
        Retry PDF link
      </Button>
    </Stack>
  );
}
